export default __webpack_public_path__ + "static/media/interface.0c3dc381.svg";